export default "__VITE_ASSET__COx5PH35__"